import {
  FOREIGN_QUALIFICATION_PRICING_TIER_STANDARD,
  FOREIGN_QUALIFICATION_PRICING_TIER_PRIORITY,
} from "constants/foreignQualificationPricingTier";

// Reuses FQ's tier values: getPriceForTier() in AddProductToCart.tsx relies on
// Payroll and FQ priority tiers being the same underlying value.
export const PAYROLL_REGISTRATION_PRICING_TIER_STANDARD =
  FOREIGN_QUALIFICATION_PRICING_TIER_STANDARD;
export const PAYROLL_REGISTRATION_PRICING_TIER_PRIORITY =
  FOREIGN_QUALIFICATION_PRICING_TIER_PRIORITY;

export type PayrollRegistrationPricingTier =
  | typeof PAYROLL_REGISTRATION_PRICING_TIER_STANDARD
  | typeof PAYROLL_REGISTRATION_PRICING_TIER_PRIORITY;

export const PAYROLL_REGISTRATION_PRICING_TIER_OPTIONS = [
  { value: PAYROLL_REGISTRATION_PRICING_TIER_STANDARD, label: "Standard" },
  { value: PAYROLL_REGISTRATION_PRICING_TIER_PRIORITY, label: "Priority" },
];

export const PAYROLL_REGISTRATION_PRICING_TIER_TURNAROUND: Record<
  PayrollRegistrationPricingTier,
  string
> = {
  [PAYROLL_REGISTRATION_PRICING_TIER_STANDARD]:
    "Usually takes 3-5 days, depending on information needed by the state",
  [PAYROLL_REGISTRATION_PRICING_TIER_PRIORITY]: "Usually takes 1-3 days",
};

// Prefilled when the selected state has no configured per-state price yet.
// Admins can still edit it via the price input.
export const PAYROLL_REGISTRATION_FALLBACK_PRICE = 150;
